import React from 'react';
import PropTypes from 'prop-types';

import * as types from '../../constants/videoLayoutTypes';
import F2FRoomPlaceholder from '../_placeholders/F2FRoomPlaceholder';
import AllowCameraPlaceholder from '../_placeholders/AllowCameraPlaceholder';
import WaitingRoomPlaceholder from '../_placeholders/WaitingRoomPlaceholder';
import DeniedCameraPlaceholder from '../_placeholders/DeniedCameraPlaceholder';
import ReconnectionPlaceholder from '../_placeholders/ReconnectionPlaceholder';
import WaitConnectionPlaceholder from '../_placeholders/WaitConnectionPlaceholder';
import ClalitWaitingRoomPlaceholder from '../_placeholders/ClalitWaitingRoomPlaceholder';
import WaitStopConnectionPlaceholder from '../_placeholders/WaitStopConnectionPlaceholder';
import AppointmentDescriptionPlaceholder from '../_placeholders/AppointmentDescriptionPlaceholder';


const propTypes = { videoLayoutBackgroundKey: PropTypes.string.isRequired };

const defaultProps = {};

const videoLayoutBackgroundMap = {
  [types.ALLOW_CAMERA]: AllowCameraPlaceholder,
  [types.DENIED_CAMERA]: DeniedCameraPlaceholder,

  [types.F2F_PLACEHOLDER]: F2FRoomPlaceholder,
  [types.WAITING_ROOM]: WaitingRoomPlaceholder,
  [types.RECONNECTION]: ReconnectionPlaceholder,
  [types.WAIT_CONNECTION]: WaitConnectionPlaceholder,
  [types.CLALIT_WAITING_ROOM]: ClalitWaitingRoomPlaceholder,
  [types.WAIT_STOP_CONNECTION]: WaitStopConnectionPlaceholder,
  [types.APPOINTMENT_DESCRIPTION]: AppointmentDescriptionPlaceholder,
};

const VideoLayoutBackgroundManager = ({ videoLayoutBackgroundKey }) =>
  React.createElement(videoLayoutBackgroundMap[videoLayoutBackgroundKey]);

VideoLayoutBackgroundManager.propTypes = propTypes;
VideoLayoutBackgroundManager.defaultProps = defaultProps;

export default VideoLayoutBackgroundManager;
